import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import './ProgramPhoneVideo.scss';

const getYouTubeEmbedUrl = (url) => {
  if (!url) {
    return '';
  }

  const suffix = "?enablejsapi=1";

  const shortsMatch = url.match(/shorts\/([a-zA-Z0-9_-]+)/);
  if (shortsMatch) {
    return `https://www.youtube.com/embed/${shortsMatch[1]}${suffix}`;
  }

  const watchMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
  if (watchMatch) {
    return `https://www.youtube.com/embed/${watchMatch[1]}${suffix}`;
  }

  if (url.includes('youtube.com/embed/')) {
    return `${url}${suffix}`;
  }

  return url;
};

const ProgramPhoneVideo = ({ videoUrl, title, className = '' }) => {
  const embedUrl = useMemo(() => getYouTubeEmbedUrl(videoUrl), [videoUrl]);

  if (!embedUrl) {
    return null;
  }

  return (
    <FlexContainer
      className={`program-phone-video ${className}`.trim()}
      alignItemsCenter
      justifyCenter
    >
      <div className="program-phone-video__device">
        <div className="program-phone-video__screen">
          <span className="program-phone-video__notch" aria-hidden="true" />
          <iframe
            className="program-phone-video__iframe"
            src={embedUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </div>
    </FlexContainer>
  );
};

ProgramPhoneVideo.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
};

ProgramPhoneVideo.defaultProps = {
  title: 'Video del programa',
  className: '',
};

export default ProgramPhoneVideo;
